// Format date - 業務邏輯：D1 的 CURRENT_TIMESTAMP 存儲 UTC，需轉換為台北時間（UTC+8），再格式化為「yyyy/mm/dd HH:mm:ss」。
export const formatDate = (dateString) => {
  if (!dateString) return '';
  const value = String(dateString).trim();

  // 處理 D1 格式（YYYY-MM-DD HH:mm:ss，UTC）
  if (/^[0-9]{4}-[0-9]{2}-[0-9]{2} [0-9]{2}:[0-9]{2}:[0-9]{2}$/.test(value)) {
    const [datePart, timePart] = value.split(' ');
    const [year, month, day] = datePart.split('-');
    const [hour, minute, second] = timePart.split(':');

    // 解析為 Date 對象（UTC）
    const date = new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}Z`);

    // 獲取 UTC 時間分量
    let y = date.getUTCFullYear();
    let mo = date.getUTCMonth() + 1;
    let d = date.getUTCDate();
    let h = date.getUTCHours();
    const mi = date.getUTCMinutes();
    const s = date.getUTCSeconds();

    // 加上 8 小時轉換為台北時間
    h += 8;
    if (h >= 24) {
      h -= 24;
      d += 1;
      // 處理月份進位
      const daysInMonth = new Date(y, mo, 0).getDate();
      if (d > daysInMonth) {
        d = 1;
        mo += 1;
        if (mo > 12) {
          mo = 1;
          y += 1;
        }
      }
    }

    return `${y}/${String(mo).padStart(2, '0')}/${String(d).padStart(2, '0')} ${String(h).padStart(2, '0')}:${String(mi).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  }

  // 日期格式（YYYY-MM-DD）
  if (/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(value)) {
    const [year, month, day] = value.split('-');
    return `${year}/${month}/${day}`;
  }

  // 若無法解析，直接返回原值
  return value;
};

// Format relative time - 業務邏輯：改為顯示絕對時間（年月日時分秒），讓用戶直觀看到確切的發佈時間。
export const formatRelativeTime = (dateString) => {
  return formatDate(dateString);
};

// Escape HTML to prevent XSS
export const escapeHtml = (text) => {
  const map = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;',
  };
  return text.replace(/[&<>"']/g, (m) => map[m]);
};

// Format content with line breaks
export const formatContent = (content) => {
  return escapeHtml(content).replace(/\n/g, '<br />');
};

// Extract text-only content from JSON blocks or plain text
export const extractTextContent = (content) => {
  if (!content) return '';
  try {
    const parsed = JSON.parse(content);
    if (Array.isArray(parsed)) {
      return parsed
        .filter(b => b.type === 'text')
        .map(b => b.content)
        .join(' ');
    }
  } catch {}
  return content;
};

// Truncate text
export const truncateText = (text, length = 100) => {
  // Extract text blocks only (skip code blocks)
  const plain = extractTextContent(text);
  if (plain.length <= length) return plain;
  return plain.substring(0, length) + '...';
};

export const getDisplayName = (userLike) => {
  if (!userLike) return '';
  return userLike.display_name || userLike.nickname || userLike.name || userLike.account || '';
};

export const getPostTypeLabel = (type) => {
  const labels = {
    EXPERIENCE: '經驗分享',
    DISCUSSION: '討論中',
  };
  return labels[type] || labels.DISCUSSION;
};

export const getPostTypeColor = (type) => {
  const colors = {
    EXPERIENCE: 'info',
    DISCUSSION: 'warning',
  };
  return colors[type] || colors.DISCUSSION;
};

export const getPostPrimaryBadgeLabel = (post) => {
  const type = post?.post_type || 'DISCUSSION';
  // 業務邏輯：討論型文章的主標籤代表解決狀態，避免同時顯示「討論中」類型與「討論中」狀態造成重複。
  if (type === 'DISCUSSION') return getStatusLabel(post?.status || 'OPEN');
  return getPostTypeLabel(type);
};

export const getPostPrimaryBadgeColor = (post) => {
  const type = post?.post_type || 'DISCUSSION';
  if (type === 'DISCUSSION') return getStatusColor(post?.status || 'OPEN');
  return getPostTypeColor(type);
};

// Get status badge color
export const getStatusColor = (status) => {
  const colors = {
    OPEN: 'warning',
    RESOLVED: 'success',
    CLOSED: 'danger',
    ACTIVE: 'success',
    DISABLED: 'danger',
  };
  return colors[status] || 'secondary';
};

// Get status label
export const getStatusLabel = (status) => {
  const labels = {
    OPEN: '討論中',
    RESOLVED: '已解決',
    CLOSED: '已關閉',
    ACTIVE: '啟用',
    DISABLED: '停用',
    EXPERIENCE: '經驗分享',
    DISCUSSION: '討論中',
  };
  return labels[status] || status;
};

